// extracted by mini-css-extract-plugin
export default {"innerWrapper":"BA-z","tooltipWrapper":"CA-z","icon":"DA-z","tooltip":"EA-z","content":"FA-z"};